import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { Button, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@bliks-io/ui';
import { useIsSalesActivated } from './useIsSalesActivated';
import { NewLeadFlow } from './NewLeadFlow';

/** Self-contained "New Lead" action: the button plus the lead flow. */
export function NewLeadButton() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const isSalesActivated = useIsSalesActivated();

  return (
    <>
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            {/* A disabled button fires no pointer events, so the tooltip needs a
                wrapper to hang the explanation off. */}
            <span>
              <Button onClick={() => setOpen(true)} disabled={!isSalesActivated}>
                <Plus className="w-4 h-4 mr-2" />
                {t('partner.newLead.button')}
              </Button>
            </span>
          </TooltipTrigger>
          {!isSalesActivated && (
            <TooltipContent>{t('partner.newLead.salesNotActivatedHint')}</TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
      <NewLeadFlow open={open} onOpenChange={setOpen} />
    </>
  );
}
